









































































































































































import { computed, ComputedRef, defineComponent, ref } from '@vue/composition-api';
import { i18n } from '@tt4b/ttam-i18n';
import { bytesToSize } from '@tt4b/ttam-utils';

import { MaterialType, VideoMaterial, FileUploadStatus, FIX_PROBLEM_TIPS_LIST } from '@tt4b/ttam-enums';
import CommonVideoSvg from '@tt4b/ttam-assets/src/images/creative/common-video.svg';
import CommonImageSvg from '@tt4b/ttam-assets/src/images/creative/common-image.svg';

const name = 'ttam-material-image-upload-progress';
export default defineComponent({
  name,
  props: {
    files: { type: Array, default: () => [] },
    fileType: { type: String, default: () => MaterialType.Video },
    inventoryCheck: { type: Boolean, default: true },
  },

  setup(props, ctx) {
    const files = computed(() => props.files) as ComputedRef<VideoMaterial[]>;
    const hasAfterVerify = computed(() => files.value.some(file => file.verifyMode));
    const uploadStatusLabelMap = ref({
      [FileUploadStatus.Cutting]: i18n.t('upload_optimizing'),
      [FileUploadStatus.Uploading]: i18n.t('upload_uploading'),
    });

    function formatSize(item) {
      return bytesToSize(item.size ?? 0);
    }

    function onRetry(file) {
      if (props.fileType === MaterialType.Image) {
        ctx.emit('retry', file);

        return;
      }
      // const { start } = useVideoUploader({ fileArr: [file] });
      // start();
    }

    function onAbort(file) {
      ctx.emit('cancel', file);
    }

    const codeMapText = (code, type) => {
      const Tips = FIX_PROBLEM_TIPS_LIST().filter(item => item.key === code);

      return Tips[0][type];
    };

    return {
      name,
      hasAfterVerify,
      uploadStatusLabelMap,
      fileUploadStatus: FileUploadStatus,
      CommonVideoSvg,
      CommonImageSvg,

      formatSize,
      onRetry,
      onAbort,
      codeMapText,
    };
  },
});
